
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { GeneralPipe, SetService,PageService } from 'ngx-block-core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-table-form-number',
  templateUrl: './table-form-number.component.html',

})
export class TableFormNumberComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() ColumnData;
  sets;
  nzFormGroupData;
  @Input() blockid = "";
  @Input() formId = "";
  @Input() columnName = "";
  @Input() index = 0;
  constructor(
    public setService: SetService,
    private generalPipe: GeneralPipe,
    private activatedRoute: ActivatedRoute,
    private pageService:PageService
  ) { }
  nzFormatter
  nzParser
  ngOnInit() {
    this.sets = this.ColumnData['nzBlockSets'];
    this.nzFormGroupData = this.ColumnData['nzFormGroupData'];
    if (this.sets.styles.nzFormat != "") {
      const arr = this.sets.styles.nzFormat.split("@value")
      if (this.sets.styles.nzDecimalPipe != "")
        this.nzFormatter = value => this.sets.styles.nzFormat.replace('@value', this.generalPipe.transform(value, 'numerical', this.sets.styles.nzDecimalPipe, 'value'));
      else
        this.nzFormatter = value => this.sets.styles.nzFormat.replace('@value', value);
      if (arr.length > 1)
        this.nzParser = value => value.replace(arr[0], '').replace(arr[1], '');
      else
        this.nzParser = value => value.replace(arr[0], '');
    } else {
      if (this.sets.styles.nzDecimalPipe != "")
        this.nzFormatter = value => this.generalPipe.transform(value, 'numerical', this.sets.styles.nzDecimalPipe, 'value');
      else
        this.nzFormatter = value => value;
      this.nzParser = value => value;
    }
    this.Listening();
  }


  needCalculate = {};
  /**
 * 计算功能初始化
 */
  initCalculate(open = true) {
    console.log('initCalculate', this.columnName);
    if (this.sets.datas.nzSameTableCalculate.nzUsed || open == false) {
      this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
        // element.field 字段名
        // element.name @v1这种
        console.log('initCalculateemit', element.field);
        this.calculate_name_key[element.name] = element.field;
        this.setService.events[this.blockid + this.formId + element.field].emit({
          type: 'needCalculate',
          datas: {
            used: open,
            id: this.columnName,
            name: element.name
          }
        });
      });
      if (open)
        this.calculateValue()
    }
  }
  ngOnDestroy() {
    this.setService.deleteEvent(this.blockid + this.formId + this.columnName)
  }
  calculate_name_key = {}
  Listening() {
    setTimeout(() => {
      console.log('initEvent', this.blockid + this.formId + this.columnName);
      this.setService.initEvent(this.blockid + this.formId + this.columnName);
      this.setService.events[this.blockid + this.formId + this.columnName].subscribe(
        data => {
          console.log('Listening', JSON.stringify(data));
          switch (data['type']) {
            case 'needCalculate':
              //变更值后通知目标积木
              this.needCalculate[data.datas.id] = data.datas;
              break;
            case 'changeCalculateValue':
              this.calculateValue()
              break;
            default:
              break;
          }

        }
      )
      setTimeout(() => {
        this.initCalculate()
      }, 100);
    }, 100);

  }
  /**
   * 计算数值
   */
  calculateValue() {
    let nzFormula = this.sets.datas.nzSameTableCalculate.nzFormula;
    //取值,替换值
    this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
      console.log("calculate_name_key:" + element.name, JSON.stringify(this.calculate_name_key));
      const value = this.form.get(this.calculate_name_key[element.name]).value;
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);
    });
    //chang
    this.sets.datas.nzSameTableCalculate.nzReplaceValueTwo.forEach(element => {
      console.log("calculate_name_keyTwo:" + JSON.stringify(element));
      let value = this.pageService.getRouteParams(this.activatedRoute, element.field)
      if (value == '') value = element.value
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);


    });

    try {
      console.log("nzFormula:" + nzFormula);
      this.form.get(this.nzFormGroupData.nzKey).patchValue(eval(nzFormula));
      console.log("nzFormulare:" + this.form.get(this.nzFormGroupData.nzKey).value);
    } catch (error) {

    }


  }
  ngModelChange(event) {
    console.log(event, this.needCalculate)
    for (const key in this.needCalculate) {
      const element = this.needCalculate[key];
      if (element.used) {
        this.setService.events[this.blockid + this.formId + element.id].emit({
          type: 'changeCalculateValue',
        });
      }
    }


  }

}
